export const list = [
  { id: '1', text: '15%', title: 'APR' },
  { id: '2', text: 'Biweekly', title: 'Re-staking Frequency' },
  { id: '3', text: 'YES', title: 'Earn Transaction Fees' },
  { id: '4', text: 'YES', title: 'EcoIP Royalties' },
  { id: '5', text: 'YES', title: 'Liquidity Pool Reward' },
  { id: '6', text: 'Validator', title: 'Status' },
];
